module.exports = __webpack_public_path__ + "img/editar_bg.76c8b63.png";